import { useQuery } from 'react-query';

import auth from '@udacity/ureact-hoth';

import { getAnonymousIdCookie } from '~/features/cookies/utils/get-anonymous-id-cookie';
import { getCouponCodeFromCookie } from '~/features/discount/utils/get-coupon-code-from-cookie';
import { usePricingExperimentVariant } from '~/features/experiments/topaz/hooks';
import { Currency } from '~/features/internationalization/models/currency';
import { getViewerCurrency } from '~/features/internationalization/utils/get-viewer-currency';

import { getPricePlans } from '../controllers/get-price-plans';

export function usePricePlans(currency: Currency = getViewerCurrency()) {
  const { variant: ghk, isLoading: variantLoading } = usePricingExperimentVariant();
  const anonymousId = getAnonymousIdCookie();
  const userId = auth.getCurrentUserId();
  const coupon = getCouponCodeFromCookie();

  return useQuery(['pricing', currency, ghk], () => getPricePlans({ currency, anonymousId, userId, coupon, ghk }), {
    enabled: Boolean(currency) && !variantLoading,
  });
}
